import HttpCliente from "../HttpCliente";

const buildQuery = (params) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== null && v !== undefined && v !== "") {
      qs.append(k, v instanceof Date ? v.toISOString() : v);
    }
  });
  return qs.toString();
};

// Admin
export const getDashboardImpactoAdmin = (token, filtros = {}) => {
  return new Promise((resolve, reject) => {
    const qs = buildQuery(filtros);
    HttpCliente.get(`/DashboardImpacto/Admin${qs ? `?${qs}` : ""}`, {
      headers: { "Authorization": `Bearer ${token}`, "Accept": "application/json" },
    }).then(r => resolve(r.data))
      .catch(e => { console.error("Error dashboard admin:", e.response?.data || e); reject(e); });
  });
};

// Usuario
export const getDashboardImpactoUsuario = (token, idUsuario, filtros = {}) => {
  return new Promise((resolve, reject) => {
    const qs = buildQuery({ idUsuario, ...filtros });
    HttpCliente.get(`/DashboardImpacto/Usuario?${qs}`, {
      headers: { "Authorization": `Bearer ${token}`, "Accept": "application/json" },
    }).then(r => resolve(r.data))
      .catch(e => { console.error("Error dashboard usuario:", e.response?.data || e); reject(e); });
  });
};

// Export Excel admin
export const exportarDashboardAdminExcel = (token, filtros = {}) => {
  return new Promise((resolve, reject) => {
    const qs = buildQuery(filtros);
    HttpCliente.get(`/DashboardImpacto/ExportarAdmin${qs ? `?${qs}` : ""}`, {
      headers: { "Authorization": `Bearer ${token}`, "Accept": "application/octet-stream" },
      responseType: "blob",
    }).then(r => resolve(r.data))
      .catch(e => { console.error("Error export admin:", e.response?.data || e); reject(e); });
  });
};

// Export Excel usuario
export const exportarDashboardUsuarioExcel = (token, idUsuario, filtros = {}) => {
  return new Promise((resolve, reject) => {
    const qs = buildQuery({ idUsuario, ...filtros });
    HttpCliente.get(`/DashboardImpacto/ExportarUsuario?${qs}`, {
      headers: { "Authorization": `Bearer ${token}`, "Accept": "application/octet-stream" },
      responseType: "blob",
    }).then(r => resolve(r.data))
      .catch(e => { console.error("Error export usuario:", e.response?.data || e); reject(e); });
  });
};

export const getCriterioImpacto = (token, idNormativa) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/DashboardImpacto/CriterioImpacto/${idNormativa}`, {
      headers: { "Authorization": `Bearer ${token}`, "Accept": "application/json" },
    }).then(r => resolve(r.data))
      .catch(e => { console.error("Error al obtener criterio de impacto:", e.response?.data || e); reject(e); });
  });
};

// Guardar evaluación de impacto (edición admin)
export const guardarEvaluacionImpacto = (token, dto) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/DashboardImpacto/GuardarEvaluacionImpacto", dto, {
      headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json", "Accept": "application/json" },
    }).then(r => resolve(r.data))
      .catch(e => { console.error("Error al guardar evaluación:", e.response?.data || e); reject(e); });
  });
};